import { render, staticRenderFns } from "./ExtraInfoWaybill.vue?vue&type=template&id=dbcfee50&"
import script from "./ExtraInfoWaybill.vue?vue&type=script&lang=js&"
export * from "./ExtraInfoWaybill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports